module.exports = __webpack_public_path__ + "static/img/bi16.ec21caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imges/bi16.png
// module id = Ct7t
// module chunks = 0